/**
 * MSAL Configuration for EntraID Authentication
 */

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_ENTRAID_CLIENT_ID || '665798df-756a-4cdb-a7cc-c4c188dee14b',
    authority: process.env.REACT_APP_ENTRAID_AUTHORITY || 'https://login.microsoftonline.com/a7f53388-893d-49a4-94df-957f5ced1518',
    redirectUri: process.env.REACT_APP_REDIRECT_URI || 'https://mysurveys.ejgallo.com',
    postLogoutRedirectUri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI || 'https://mysurveys.ejgallo.com',
  },
  cache: {
    cacheLocation: 'sessionStorage', // Use sessionStorage for better security
    storeAuthStateInCookie: false, // Set to true for IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case 0: // Error
            console.error(message);
            return;
          case 1: // Warning
            console.warn(message);
            return;
          case 2: // Info
            console.info(message);
            return;
          case 3: // Verbose
            console.debug(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

/**
 * Scopes for login request
 */
export const loginRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email'],
};

/**
 * Scopes for Graph API calls
 */
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
